/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import UserOrganizationPayloadItemModel from './UserOrganizationPayloadItemModel';

/**
 * The PatchUserPayloadModel model module.
 * @module model/PatchUserPayloadModel
 * @version v1.0.0
 */
class PatchUserPayloadModel {
    /**
     * Constructs a new <code>PatchUserPayloadModel</code>.
     * @alias module:model/PatchUserPayloadModel
     */
    constructor() { 
        
        PatchUserPayloadModel.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PatchUserPayloadModel</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PatchUserPayloadModel} obj Optional instance to populate.
     * @return {module:model/PatchUserPayloadModel} The populated <code>PatchUserPayloadModel</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PatchUserPayloadModel();

            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('mapping')) {
                obj['mapping'] = ApiClient.convertToType(data['mapping'], [UserOrganizationPayloadItemModel]);
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
        }
        return obj;
    }


}

/**
 * user description
 * @member {String} description
 */
PatchUserPayloadModel.prototype['description'] = undefined;

/**
 * user email
 * @member {String} email
 */
PatchUserPayloadModel.prototype['email'] = undefined;

/**
 * mapping
 * @member {Array.<module:model/UserOrganizationPayloadItemModel>} mapping
 */
PatchUserPayloadModel.prototype['mapping'] = undefined;

/**
 * user name
 * @member {String} name
 */
PatchUserPayloadModel.prototype['name'] = undefined;






export default PatchUserPayloadModel;

